import { Navigate, Route, Routes, useParams } from 'react-router-dom'
import { AuthProvider } from '@orisini/ui/context/AuthContext'
import AppShell from './components/layout/AppShell'
import ProtectedRoute from './components/layout/ProtectedRoute'
import ForgotPasswordPage from './features/auth/pages/ForgotPasswordPage'
import LoginPage from './features/auth/pages/LoginPage'
import RegisterPage from './features/auth/pages/RegisterPage'
import ResetPasswordPage from './features/auth/pages/ResetPasswordPage'
import VerifyEmailPage from './features/auth/pages/VerifyEmailPage'
import AdminPage from './features/admin/pages/AdminPage'
import BillingPage from './features/billing/pages/BillingPage'
import DevicesPage from './features/devices/pages/DevicesPage'
import DownloadPage from './features/download/pages/DownloadPage'
import LandingPage from './features/home/pages/LandingPage'
import PrivacyPage from './features/legal/pages/PrivacyPage'
import TermsPage from './features/legal/pages/TermsPage'
import DashboardPage from './features/accounts/pages/DashboardPage'
import NewProjectPage from './features/accounts/pages/NewProjectPage'
import ProjectPage from './features/accounts/pages/ProjectPage'
import ProjectsPage from './features/accounts/pages/ProjectsPage'
import PublishingQueuePage from './features/queue/pages/PublishingQueuePage'
import DiscoverPage from './features/discover/pages/DiscoverPage'
import ReviewPage from './features/content/pages/ReviewPage'
import BankPage from './features/content/pages/BankPage'
import ContentPage from './features/content/pages/ContentPage'
import CreatePage from './features/content/pages/CreatePage'
import SettingsPage from './features/settings/pages/SettingsPage'

/**
 * Router orisini.com.
 *
 * `idOrigin` tidak diisi karena di sini Worker identitas ADALAH origin-nya
 * sendiri; SPA produk yang mengisinya dengan https://orisini.com.
 */
export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        {/* Publik: calon user harus bisa melihat aplikasinya sebelum punya akun. */}
        <Route path="/download" element={<DownloadPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        {/* Alamat lama sebelum antarmukanya pindah ke bahasa Inggris; tautan yang
            sudah tersebar tidak boleh mendarat di halaman kosong. */}
        <Route path="/unduh" element={<Navigate to="/download" replace />} />

        <Route
          path="/app"
          element={
            <ProtectedRoute>
              <AppShell />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardPage />} />
        </Route>

        <Route
          element={
            <ProtectedRoute>
              <AppShell />
            </ProtectedRoute>
          }
        >
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/projects/new" element={<NewProjectPage />} />
          <Route path="/projects/:id" element={<ProjectPage />} />
          {/* Tab project di URL supaya refresh mendarat di tab yang sama. */}
          <Route path="/projects/:id/:tab" element={<ProjectPage />} />
          {/* Alamat lama sebelum "akun" berganti nama menjadi Project (2026-11-04). */}
          <Route path="/accounts/new" element={<Navigate to="/projects/new" replace />} />
          <Route path="/accounts/:id" element={<AlamatLama />} />
          <Route path="/accounts/:id/:tab" element={<AlamatLama />} />
          <Route path="/queue" element={<PublishingQueuePage />} />
          <Route path="/discover" element={<DiscoverPage />} />
          <Route path="/create" element={<CreatePage />} />
          <Route path="/review" element={<ReviewPage />} />
          <Route path="/bank" element={<BankPage />} />
          <Route path="/content/:id" element={<ContentPage />} />
          {/* Editor Studio dihapus 2026-11-04: Create + Content Bank menggantikannya. */}
          <Route path="/studio" element={<Navigate to="/create" replace />} />
          <Route path="/studio/*" element={<Navigate to="/create" replace />} />
          <Route path="/billing" element={<BillingPage />} />
          <Route path="/devices" element={<DevicesPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/admin" element={<AdminPage />} />
          {/* Tab admin ada di URL supaya refresh mendarat di panel yang sama. */}
          <Route path="/admin/:tab" element={<AdminPage />} />
        </Route>
      </Routes>
    </AuthProvider>
  )
}

function AlamatLama() {
  const { id = '', tab } = useParams()
  return <Navigate to={tab ? `/projects/${id}/${tab}` : `/projects/${id}`} replace />
}
